/** @jsxImportSource @emotion/react */
import React, { ReactNode } from 'react';
import t, { CSSStyle } from '../theme/styles';

export function Page(props: { style?: CSSStyle; children?: ReactNode }) {
    return <div css={[t.pageWidth, t.flex, t.flex_col, t.px_5, t.sm([t.px_6]), t.md([t.px_7]), props.style]}>{props.children}</div>;
}
